import { Map } from 'immutable';

import { appel as artisanAppel } from '../../actions/artisan';
import { sliceNumber } from '../Calls/FomatText';

export const artisanNumbers =
  [1, 2, 3].map(e => ({
    name: `Téléphone Artisan ${e}`,
    value: (props, elem) => {
      let tel = '';
      if (props.markerList && props.markerList.size) {
        const artisan = props.markerList.find(
          e => e.getIn(['obj', 'value']) === elem.artisan
        );
        tel = artisan && artisan.getIn(['obj', `tel${e}`]);
      }
      const numberToSlice =
      tel || (elem?.currentArtisan && elem?.currentArtisan[`tel${e}`])
      return (
        sliceNumber(numberToSlice)
      );
    },
    action: (props, elem) => {
      let tel = '';
      const artisan = (props.markerList || []).find(
        e => e.getIn(['obj', 'value']) === elem.artisan
      );
      if (artisan && props.markerList && props.markerList.size) {
        tel = artisan.getIn(['obj', `tel${e}`]);
      } else if (
        props.selected &&
              props.selected.artisan &&
              elem.currentArtisan &&
              elem.currentArtisan[`tel${e}`]
      ) {
        tel = elem.currentArtisan[`tel${e}`];
      }
      return (
        tel &&
        artisanAppel(
          {
            artisan: new Map((artisan || {}).obj || elem.currentArtisan),
            intervention: new Map(props.selected),
          },
          tel
        )
      );
    },
  }));
